module.exports = __webpack_public_path__ + "img/Indeni.c57dba94.jpg";